import React from "react";
import {toAbsoluteUrl} from '../../../../_metronic/_helpers';
import DataItemSelect from '../../_common/components/DataItemSelect';
import {useUserDetailsUIContext} from '../UserDetailsUIContext';
import {userDataHistorySelectStyles} from '../../_common/styles/reactSelectStyles';

export default function SelectHistoryPoint() {
  const {formik, historyOptions} = useUserDetailsUIContext();

  return historyOptions.length > 0 && (
    <div className={'d-flex align-items-center'}>
      <DataItemSelect
        fieldId={'historyPoint'}
        options={historyOptions}
        customStyles={userDataHistorySelectStyles}
        placeholder={'המצב הנוכחי'}
      />
      <img
        src={toAbsoluteUrl('/media/svg/Cross_primary.svg')}
        className={'cursor-pointer'}
        alt="clear"
        onClick={() => {formik.setFieldValue('historyPoint', null)}}
      />
    </div>
  );
}
